import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { HeaderComponent } from '../../../shared/header/header.component';
import { RelatorioTermos, TermoRelatorioItem } from '../../../../interfaces/relatorios.dto';
import { RelatoriosAbasComponent } from '../relatorios-abas/relatorios-abas.component';
import { RelatoriosService } from '../../../../services/relatorios/relatorios.service';

@Component({
  selector: 'app-termos-adesao',
  standalone: true,
  imports: [CommonModule, FormsModule, HeaderComponent, RouterLink, RelatoriosAbasComponent],
  templateUrl: './termos-adesao.component.html',
  styleUrl: './termos-adesao.component.scss',
})
export class TermosAdesaoComponent {
  cpf = '';
  resultado: RelatorioTermos | null = null;
  carregando = false;
  buscou = false;
  erro = '';
  erroDownload = '';
  baixando = new Set<string>();
  readonly skeleton = [1, 2, 3];

  private cpfBuscado = '';
  // Descarta a resposta de uma busca já superada por outra.
  private carga = 0;

  constructor(private relatorios: RelatoriosService) {}

  aoDigitar(valor: string): void {
    const d = (valor ?? '').replace(/\D/g, '').slice(0, 11);
    let m = d;
    if (d.length > 9) m = `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
    else if (d.length > 6) m = `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
    else if (d.length > 3) m = `${d.slice(0, 3)}.${d.slice(3)}`;
    this.cpf = m;
  }

  async buscar(): Promise<void> {
    const digitos = this.cpf.replace(/\D/g, '');
    this.erro = '';
    this.erroDownload = '';

    if (digitos.length !== 11) {
      this.erro = 'Informe um CPF válido.';
      return;
    }

    const minha = ++this.carga;
    this.carregando = true;
    this.buscou = true;
    this.resultado = null;

    try {
      const r = await this.relatorios.termos(digitos);
      if (minha !== this.carga) return;
      this.cpfBuscado = digitos;
      this.resultado = r;
    } catch (e: any) {
      if (minha !== this.carga) return;
      this.erro = e?.message || 'Registro de termos indisponível agora.';
    } finally {
      if (minha === this.carga) this.carregando = false;
    }
  }

  async baixar(t: TermoRelatorioItem): Promise<void> {
    if (this.baixando.has(t.id)) return;

    this.baixando.add(t.id);
    this.erroDownload = '';
    try {
      await this.relatorios.baixarTermo(t.id, this.cpfBuscado);
    } catch (e: any) {
      this.erroDownload = e?.message || 'Não foi possível baixar o termo agora.';
    } finally {
      this.baixando.delete(t.id);
    }
  }

  rotuloCanal(canal: string): string {
    switch ((canal ?? '').toLowerCase()) {
      case 'importado': return 'Importado';
      case 'sms': return 'SMS';
      case 'email': return 'E-mail';
      default: return canal;
    }
  }

  classeCanal(canal: string): string {
    switch ((canal ?? '').toLowerCase()) {
      case 'importado': return 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200';
      case 'sms': return 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200';
      default: return 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200';
    }
  }
}
